// src/api/services/auth.ts
import { api } from './index';

export interface LoginRequest {
    username: string;
    password: string;
}

export interface LoginResponse {
    access_token: string;
    refresh_token: string;
}

export interface RefreshTokenRequest {
    refresh_token: string;
}

export interface RefreshTokenResponse {
    access_token: string;
    refresh_token: string;
}

export interface User {
    id: string;
    username: string;
    email?: string;
    webAllowed?: boolean;
    isAdmin?: boolean;
    // Add other user properties as needed
}

export interface UserInfoResponse {
    data: User;
}

export const authService = {
    /**
     * Login with username and password
     */
    login: (data: LoginRequest) =>
        api.post<LoginResponse>('/auth/login', data),

    /**
     * Refresh the access token using a refresh token
     */
    refreshToken: (data: RefreshTokenRequest) =>
        api.post<RefreshTokenResponse>('/auth/refresh', data),

    /**
     * Logout the current user
     */
    logout: () =>
        api.post('/auth/logout'),

    getProfile: () =>
        api.get<UserInfoResponse>('/auth/me/info'),
};